import React from 'react';

const AICircleIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <g clip-path="url(#clip0_9150_149128)">
        <path
          d="M7.06201 0.70223C7.18499 0.712242 7.30372 0.752172 7.4078 0.818441L7.4585 0.85376L7.50635 0.893636C7.59821 0.97595 7.66861 1.07931 7.71143 1.19499L7.73079 1.25366L7.73307 1.26335L8.65535 4.84196C8.68662 4.96301 8.74981 5.0737 8.83822 5.16211C8.9265 5.25036 9.03696 5.31311 9.1578 5.3444L12.737 6.26668L12.745 6.26896C12.8849 6.3076 13.0102 6.38558 13.1067 6.49284L13.1466 6.54069L13.1819 6.59139C13.2597 6.71298 13.3015 6.85465 13.3015 6.99984C13.3015 7.16581 13.2471 7.3275 13.1466 7.45955C13.046 7.59155 12.9049 7.68712 12.745 7.73128L12.737 7.73299L9.15837 8.65527C9.03726 8.68652 8.92666 8.74969 8.83822 8.83813C8.74979 8.92658 8.6866 9.03718 8.65535 9.15828L7.7325 12.7369C7.73172 12.7399 7.73107 12.743 7.73022 12.746C7.68562 12.9054 7.58978 13.0459 7.45793 13.1459C7.32611 13.2459 7.16535 13.3003 6.99992 13.3003C6.83442 13.3003 6.67319 13.2459 6.54134 13.1459C6.40958 13.0459 6.3142 12.9053 6.26961 12.746C6.26877 12.743 6.26812 12.7399 6.26733 12.7369L5.34505 9.15828C5.31381 9.0372 5.2506 8.92657 5.16219 8.83813C5.09577 8.77171 5.0168 8.71941 4.93034 8.68433L4.84204 8.65527L1.26343 7.73242C1.25988 7.73151 1.25613 7.73057 1.2526 7.72957C1.09389 7.68453 0.953896 7.58889 0.854411 7.45728C0.754922 7.32562 0.701172 7.16486 0.701172 6.99984C0.701203 6.83491 0.754998 6.67457 0.854411 6.54297L0.893717 6.49512C0.989268 6.38805 1.11375 6.31008 1.2526 6.27067L1.26343 6.26725L4.84204 5.34383C4.96308 5.3126 5.07377 5.2499 5.16219 5.16154C5.25063 5.07315 5.31375 4.96244 5.34505 4.84139L6.2679 1.26278L6.27018 1.25366C6.31479 1.09436 6.41011 0.953752 6.54191 0.85376L6.59318 0.818441C6.71452 0.741189 6.85579 0.699951 7.00049 0.699951L7.06201 0.70223ZM6.24854 5.07495C6.1755 5.35743 6.02824 5.61554 5.82186 5.82178C5.64131 6.00219 5.42124 6.13733 5.17985 6.21712L5.07503 6.24788L2.15951 6.99984L5.07503 7.75179L5.17985 7.78255C5.42126 7.86239 5.64132 7.99742 5.82186 8.1779C6.02825 8.38429 6.17562 8.64267 6.24854 8.92529L6.99992 11.8408L7.75187 8.92529C7.82478 8.64267 7.97216 8.38429 8.17855 8.1779C8.3849 7.97163 8.64286 7.82467 8.92537 7.75179V7.75122L11.8415 6.99984L8.92537 6.24845C8.64279 6.17555 8.38492 6.02812 8.17855 5.82178C7.97218 5.61541 7.82479 5.35754 7.75187 5.07495L7.00049 2.15885L6.24854 5.07495Z"
          fill="url(#paint0_linear_9150_149128)"
        />
        <path d="M11.2002 1.28345H12.1333V4.54989H11.2002V1.28345Z" fill="url(#paint1_linear_9150_149128)" />
        <path d="M13.2996 2.45007V3.38318H10.0332V2.45007H13.2996Z" fill="url(#paint2_linear_9150_149128)" />
        <path d="M1.94434 9.52759H2.72249V11.4724H1.94434V9.52759Z" fill="url(#paint3_linear_9150_149128)" />
        <path d="M3.30615 10.111V10.8891H1.36133V10.111H3.30615Z" fill="url(#paint4_linear_9150_149128)" />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_9150_149128"
          x1="13.2164"
          y1="6.3251"
          x2="3.61893"
          y2="1.35171"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#994EFE" />
          <stop offset="0.5" stop-color="#4A8CF8" />
          <stop offset="1" stop-color="#994EFE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9150_149128"
          x1="12.127"
          y1="2.74168"
          x2="11.2447"
          y2="2.61108"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#994EFE" />
          <stop offset="0.5" stop-color="#4A8CF8" />
          <stop offset="1" stop-color="#994EFE" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_9150_149128"
          x1="13.2776"
          y1="2.86664"
          x2="12.542"
          y2="1.5323"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#994EFE" />
          <stop offset="0.5" stop-color="#4A8CF8" />
          <stop offset="1" stop-color="#994EFE" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_9150_149128"
          x1="2.71724"
          y1="10.3958"
          x2="1.99636"
          y2="10.2463"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#994EFE" />
          <stop offset="0.5" stop-color="#4A8CF8" />
          <stop offset="1" stop-color="#994EFE" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_9150_149128"
          x1="3.29301"
          y1="10.4584"
          x2="2.59115"
          y2="9.54936"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#994EFE" />
          <stop offset="0.5" stop-color="#4A8CF8" />
          <stop offset="1" stop-color="#994EFE" />
        </linearGradient>
        <clipPath id="clip0_9150_149128">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AICircleIcon;
